
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkAccountingPartner } from '../models/work-accounting-partner';

export function getExternalSupplierCreatedDtoFormGroup() {
return new FormGroup({
    partner: new FormControl<WorkAccountingPartner | undefined>(undefined, [Validators.required]),
    warnings: new FormControl<Array<string> | undefined>([], [Validators.required]),
})
;
}
      